export const ENV_TESTNET = 'testnet' as const;
export const ENV_PRODUCTION = 'production' as const;

// Build-only AMM override; the wallet network and other services are unchanged.
export const AMM_STAGING_PREVIEW =
    (process as typeof process & { variable?: { AMM_STAGING_PREVIEW?: boolean } }).variable
        ?.AMM_STAGING_PREVIEW === true;
